import * as React from 'react';
import { ExpertsContainer } from '../../containers';

const ExpertsPage: React.FC = () => (
  <ExpertsContainer />
);


export default ExpertsPage;
